import * as React from 'react'

import './styles.scss'
import { getStaticImage } from 'utils/statics'

const ProcessesList = (props) => {
  const { processes = [], edit, remove } = props

  return (
    <div className='processes-list'>
      {
        processes.map((it) => {
          return (
            <div key={it._id} className='animated fadeIn'>
              <div className='process'>
                <span className='name'>{it.label}</span>
                <div className='process-icons'>
                  <img src={getStaticImage('/icons/orange-brand/icon-edit.svg')} alt='Edit' onClick={()=>edit(it)}/>
                  {!it.notAllowDelete && <img src={getStaticImage('/icons/orange-brand/icon-delete.svg')} alt='Delete' onClick={()=>remove(it)}/>}
                </div>
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export default ProcessesList